var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEsiaLogo = function SvgEsiaLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#EsiaLogo_svg__a)",
    d: "M35.95 14.734c-.138-1.804-1.513-4.117-2.89-5.227a52.492 52.492 0 0 0-4.814-3.146 53.48 53.48 0 0 0-5.09-2.683 7.386 7.386 0 0 0-2.936-.555 7.231 7.231 0 0 0-2.935.555 53.825 53.825 0 0 0-5.09 2.683C9.535 7.981 7.38 9.507 7.38 9.507a8.562 8.562 0 0 0-2.613 3.885.178.178 0 0 0 .17.232h2.75a.375.375 0 0 0 .324-.193c.41-.726.95-1.379 1.6-1.923 0 0 1.779-1.252 3.975-2.58a44.556 44.556 0 0 1 4.203-2.2 6.008 6.008 0 0 1 2.423-.455 6.136 6.136 0 0 1 2.424.455 44.279 44.279 0 0 1 4.203 2.2 43.388 43.388 0 0 1 3.976 2.58c1.136.91 2.271 2.807 2.385 4.286 0 0 .265 2.2.303 4.806a45.101 45.101 0 0 1-.265 4.818 7.02 7.02 0 0 1-2.423 4.286s-1.78 1.29-3.976 2.618a44.592 44.592 0 0 1-4.203 2.2 6.009 6.009 0 0 1-2.424.455 6.136 6.136 0 0 1-2.423-.444 44.262 44.262 0 0 1-4.203-2.2c-2.196-1.29-3.976-2.617-3.976-2.617-.56-.45-1.122-1.14-1.564-1.902a.373.373 0 0 0-.321-.187H4.94c-.123 0-.21.119-.17.235.524 1.477 1.566 3.008 2.609 3.85 0 0 2.155 1.618 4.815 3.191a53.476 53.476 0 0 0 5.09 2.683c.932.378 1.93.563 2.935.541a7.23 7.23 0 0 0 2.935-.555 53.825 53.825 0 0 0 5.09-2.683 77.543 77.543 0 0 0 4.816-3.192 8.576 8.576 0 0 0 2.935-5.227 55.35 55.35 0 0 0 .32-5.875c-.045-3.178-.366-5.861-.366-5.861z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0066B3",
    d: "M4.123 16.776a.7.7 0 0 1 .7-.7h10.842a.7.7 0 0 1 .7.7v2.1a.7.7 0 0 1-.7.7H4.123v-2.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EE2F53",
    d: "M4.124 21.677h22.034a.7.7 0 0 1 .7.7v2.1a.7.7 0 0 1-.7.7H4.823a.7.7 0 0 1-.7-.7v-2.8z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "EsiaLogo_svg__a",
    x1: 20.505,
    x2: 20.505,
    y1: 3.121,
    y2: 38.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#0066B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#EE2F53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE2F53"
  })))));
};
export default SvgEsiaLogo;